// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyCreateWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyCreateWebApiHandler_create } from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingType,
  PropertyType,
  UserPropertyCreateResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface CreateParams {
  customerId?: string;
  fullAddress: string;
  includeWebAnalytics?: boolean;
  listingType: ListingType;
  numUnits?: number;
  propertyType: PropertyType;
  unitNumber?: string;
}

export interface RentalManagerUserPropertyCreateWebApiHandler_create_Args {
  getParams: CreateParams;
}

export type RentalManagerUserPropertyCreateWebApiHandler_create_Options = UseMutationOptions<
  UserPropertyCreateResponseWebDto,
  unknown,
  RentalManagerUserPropertyCreateWebApiHandler_create_Args
>;

/**
 * Create a property for the user
 * @deprecated
 */
export const useRentalManagerUserPropertyCreateWebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyCreateWebApiHandler_create_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyCreateWebApiHandler_create_Args) =>
      RentalManagerUserPropertyCreateWebApiHandler_create(args.getParams, httpClient),
  });
};
